//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      isVisible: false,
      remainingTime: 0,
      timerInterval: null,

      timerDuration: 60
    }
  },

  methods: {
    start: function () {
      this.isVisible = true
      this.remainingTime = this.timerDuration

      // Очищаем предыдущий таймер если он есть
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }

      // Запускаем новый таймер
      this.timerInterval = setInterval(() => {
        this.remainingTime--

        if (this.remainingTime <= 0) {
          this.stop()
        }
      }, 1000)
    },

    stop: function () {
      this.remainingTime = 0
      // НЕ скрываем компонент, чтобы пользователь мог нажать кнопку

      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },

    formatTime: function (seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60

      if (minutes > 0) {
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
      } else {
        return `${remainingSeconds}с`
      }
    },

    onSendClick: function () {
      // Проверяем, закончился ли таймер
      if (this.remainingTime > 0) {
        return // Не выполняем действие если таймер еще идет
      }

      // Эмитим событие для родительского компонента
      console.log('onSendClick: ')
      this.$emit('sendCode')

      // Скрываем компонент после отправки
      this.isVisible = false
    }
  },

  beforeDestroy() {
    // Очищаем таймер при уничтожении компонента
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }

}
